import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Translate from "./translate"
import { useLocation } from '@reach/router';
import X from "./icons/x"
import Facebook from "./icons/facebook"
import Instagram from "./icons/instagram"
import StyledImage from "./styled-image";
import { ScrollToTop } from "./scroll-to-top";
import YouTube from "./icons/youtube";

export default function Footer() {
  const data = useStaticQuery(graphql`
    {
      wpMenu(name: { eq: "Footer" }) {
        menuItems {
          nodes {
            id
            title: label
            uri
            target
            parent: parentId
            cssClasses
          }
        }
      }
      policiesMenu: wpMenu(name: { eq: "Policies" }) {
        menuItems {
          nodes {
            id
            title: label
            uri
            target
            parent: parentId
            cssClasses
          }
        }
      }
      wpOption(id: { eq: "cG9zdDo5OA==" }) {
        footer {
          footerMenu {
            logo {
              altText
              localFile {
                publicURL
                extension
                childImageSharp {
                  gatsbyImageData(width: 110)
                }
              } 
            }
            contactDetails
            copyright
            googleMap
            socialMedia {
              type
              url
            }
          }
        }
      }
    }
  `)
  const { socialMedia, copyright, contactDetails, googleMap, logo } = data?.wpOption?.footer?.footerMenu
  const routes = data?.wpMenu?.menuItems?.nodes
  const policiesRoutes = data?.policiesMenu?.menuItems?.nodes
  const location = useLocation();

  return (
    <footer>
      <div className="bg-white font-medium print:hidden">
        <div className="py-8 lg:py-12">
          <div className="container">
            <div className="flex flex-wrap justify-center lg:justify-start">
              <StyledImage
                image={logo}
                className={`w-28 h-auto`}
                objectFit={`contain`}
              />
            </div>
            {routes?.length ? (
              <nav className="" aria-label="Footer navigation">
                <ul className="pt-4 sm:masonry sm:masonry-cols-2 sm:col-gap-4 md:masonry-cols-3 2xl:masonry-cols-4 text-sm lg:text-base">
                  <>
                    {routes?.map(({ uri, target, cssClasses, title }, index) => {
                      return (
                        <>
                          <li key={"menu-" + index} className="py-2">
                            <Link
                              to={uri}
                              target={target}
                              aria-label={`${title}${target === "_blank" ? " (opens in a new tab)" : ""}`}
                              className={`text-body font-medium leading-tight py-1 my-1 hover:text-green focus:text-green ${cssClasses
                                ? cssClasses
                                  .toString()
                                  .replace(/,/g, " ")
                                : ""
                                } 
                              
                              `}
                            >
                              {title}
                            </Link>
                          </li>
                        </>
                      )
                    })}
                  </>
                  <li className="break-before-column">
                    {contactDetails && (
                      <div
                        className={`parsed-content links-body pt-2 footer-contact-details`}
                        dangerouslySetInnerHTML={{
                          __html: contactDetails,
                        }}
                      />
                    )}
                    {socialMedia ?
                      <ul className="mr-auto md:mr-0 flex items-center space-x-3 ml-auto pt-4">
                        {socialMedia?.map((socialMediaLink) => {
                          return (
                            <li key={socialMediaLink.type} className="flex items-center">
                              <a
                                href={socialMediaLink.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`inline-flex items-center text-white hover-grow hover:text-bright-blue focus:text-bright-blue`}
                                aria-label={`${socialMediaLink.type} (opens in a new tab)`}

                              >
                                {socialMediaLink.type === "X" ? (
                                  <X className="w-[1.875rem] h-[1.875rem]" />
                                ) : socialMediaLink.type === "Facebook" ? (
                                  <Facebook className="w-[1.875rem] h-[1.875rem]" />
                                ) : socialMediaLink.type === "Instagram" ? (
                                  <Instagram className="w-[1.875rem] h-[1.875rem]" />
                                ) : socialMediaLink.type === "YouTube" ? (
                                  <YouTube className="w-[1.875rem] h-[1.875rem]" />
                                ) : null}
                              </a>
                            </li>
                          )
                        })}
                      </ul>
                      : null}
                    <div className="font-semibold min-w-[11rem] max-w-[13rem] sm:max-w-none relative">
                      <Translate isActive={location?.hash?.includes("#translate")} />
                    </div>
                  </li>

                </ul>
              </nav>
            ) : null}
          </div>
          {googleMap ? <div className="google-map-w-full pt-8 lg:pt-10 lg:container" dangerouslySetInnerHTML={{ __html: googleMap }} /> : null}

          <div className="pt-8 lg:pt-12 pb-12 sm:text-center container text-sm">
            <hr className="hidden lg:block mb-8" />
            {copyright ? <div>Copyright © {new Date().getFullYear()} {copyright}</div> : null}
            {policiesRoutes?.length ? (
              <nav className="mt-4" aria-label="policy navigation">
                <ul className="sm:flex sm:flex-wrap text-sm sm:justify-center -mx-4">
                  <>
                    {policiesRoutes?.map(({ uri, target, cssClasses, title }, index) => {
                      return (
                        <>
                          <li key={"menu-" + index} className="py-2 mx-4">
                            <Link
                              to={uri}
                              target={target}
                              className={`text-body font-medium leading-tight py-1 my-1 hover:text-green focus:text-green ${cssClasses
                                ? cssClasses
                                  .toString()
                                  .replace(/,/g, " ")
                                : ""
                                } 
                              
                              `}
                            >
                              {title}
                            </Link>
                          </li>
                        </>
                      )
                    })}
                  </>
                </ul>
              </nav>
            ) : null}
          </div>

        </div>
      </div>
      <ScrollToTop />
    </footer>
  )
}
